module.exports = __webpack_public_path__ + "media/country_flags/il-17f0786b.png";